import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 22 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M11 11.93c.24 0 .48-.09.66-.27l8.45-8.46v5.57c0 .51.42.93.93.93s.93-.42.93-.93V.96c0-.51-.42-.93-.93-.93h-7.81c-.51 0-.93.42-.93.93s.42.93.93.93h5.57l-8.45 8.45a.93.93 0 0 0 0 1.31c.18.18.42.27.66.27Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M21.04 13.39a.96.96 0 0 0-.96.96v4.46c0 .7-.57 1.27-1.27 1.27H3.19c-.7 0-1.27-.57-1.27-1.27V3.19c0-.7.57-1.27 1.27-1.27h4.46a.96.96 0 0 0 0-1.92H3.19C1.43 0 0 1.43 0 3.19v15.62C0 20.57 1.43 22 3.19 22h15.62c1.76 0 3.19-1.43 3.19-3.19v-4.46a.96.96 0 0 0-.96-.96"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }